export const formatTitle = (title: string | undefined) => {
  const maxChars = 90;

  if (title && title.length < maxChars) {
    const words = title.split(' ');
    let count = 0;
    let newTitle = '';
    for (const word of words) {
      if (count + word.length > maxChars) {
        newTitle += '...';
        break;
      }
      newTitle += word + ' ';
      count += word.length;
    }
    return newTitle;
  } else if (title) {
    return title;
  }

  return 'Ingen programtitel';
};

export default formatTitle;
